import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.2);
  width: 60em;
  max-width: 30em;
  max-height: 80vh;
  padding: 2em;
  margin: 2em;
  text-align: center;

  h1 {
    color: #0db14b;
    margin-bottom: 0.5em;
  }

  p {
    font-size: 1.2em;
    margin-bottom: 0.8em;
  }

  button {
    padding: 0.5em 0.6em;
    margin: 0.5em;
    border-radius: 5px;
    border: 0;
  }

  #unio-portal-btn {
    background: #0db14b;
    color: #fff;
    font-weight: bold;
  }

  #old-portal-btn {
    background: #d1d1d1;
  }

  @media only screen and (max-width: 768px) {
    max-width: 90vw;
    max-height: 90vh;
  }
`;
